var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaferGamblingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.652 2.129c.224-.083.472-.083.696 0l8 2.963c.392.145.652.52.652.938v4.12a12.165 12.165 0 01-7.534 11.247l-1.152.474a.825.825 0 01-.627 0l-1.153-.474A12.163 12.163 0 013 10.15V6.03c0-.418.26-.793.652-.938l8-2.963zm4.37 6.333a.75.75 0 00-1.06.015l-4.309 4.445-1.615-1.666-.056-.053a.751.751 0 00-1.07 1.039l.05.058 1.974 2.037a1 1 0 001.436 0l4.666-4.815a.75.75 0 00-.015-1.06z",
    fill: "currentColor"
  })));
}
SvgSaferGamblingFilled.displayName = 'SaferGamblingFilled';
export default SvgSaferGamblingFilled;